import { useSyncExternalStore } from 'react';

/**
 * Közös „váltó" ütem — az aktivitáskártyák láblécéhez (terület ⇄ mezőszám).
 *
 * ⚠️ EGYETLEN IDŐZÍTŐ az összes kártyára (ugyanaz az elv, mint a toplistánál,
 * `Leaderboard.tsx` → `useValueSwap`): egy feed húsz kártyája húsz külön
 * `setInterval`-lal pazarlás lenne, és szétcsúszva villogna. Az időzítő csak
 * addig fut, amíg van feliratkozó.
 */

const SWAP_MS = 3000;

let showSecond = false;
let timer: number | undefined;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (timer === undefined) {
    timer = window.setInterval(() => {
      showSecond = !showSecond;
      listeners.forEach((notify) => notify());
    }, SWAP_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== undefined) {
      window.clearInterval(timer);
      timer = undefined;
      showSecond = false;
    }
  };
}

/** `false` → az első érték látszik, `true` → a második. Minden hívó ugyanazt kapja. */
export function useSharedSwap(enabled: boolean): boolean {
  const value = useSyncExternalStore(
    enabled ? subscribe : subscribeNothing,
    () => showSecond,
    () => false,
  );
  return enabled && value;
}

function subscribeNothing(): () => void {
  return () => {};
}
